<template>
  <base-form
    v-slot="slotProps"
    :model="qrCode"
    :rules="rules"
    :loading="loading"
    :form-submitted="formSubmitted"
    :submit-label="submitLabel"
    :mode="mode"
    model-name="QR-Code"
  >
    <el-form-item label="Bezeichnung" prop="label">
      <el-input
        v-model="slotProps.model.label"
        v-focus
        placeholder="z.B. Flyer Kindergarten"
      ></el-input>
    </el-form-item>

    <el-form-item label="Ziel" prop="target_id">
      <el-cascader
        v-model="selectedTarget"
        :options="guideItemsForCascader"
        :props="{
          multiple: false,
          checkStrictly: true,
          emitPath: false,
          expandTrigger: 'hover'
        }"
        placeholder="Ziel auswählen"
        style="width: 100%;"
        filterable
        @change="handleTargetChange"
      ></el-cascader>
    </el-form-item>
  </base-form>
</template>

<script>
import GuideItemsRepository from "@/repositories/guide_items_repository.js"
import BaseForm from "@/components/forms/BaseForm"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

const ALLOWED_TYPES = ["folder", "articles", "institutions"]

export default {
  components: {
    BaseForm
  },
  mixins: [ApiErrorHandlerMixin],
  props: {
    qrCode: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLabel: {
      type: String,
      default: "Änderungen speichern"
    },
    formSubmitted: {
      type: Function,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingGuideItems: true,
      guideItems: [],
      selectedTarget: null,
      rules: {
        label: [
          {
            required: true,
            message: "Bitte Bezeichnung angeben",
            trigger: "blur"
          }
        ],
        target_id: [
          {
            required: true,
            message: "Bitte Ziel auswählen",
            trigger: "change"
          }
        ]
      }
    }
  },
  computed: {
    guideItemsForCascader() {
      return this.parseGuideItemTree(this.guideItems)
    }
  },
  watch: {
    qrCode: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.target_id && newVal.target_type) {
          this.selectedTarget = `${newVal.target_type}:${newVal.target_id}`
        }
      }
    },
    guideItems: {
      handler() {
        if (this.qrCode && this.qrCode.target_id && this.qrCode.target_type) {
          this.selectedTarget = `${this.qrCode.target_type}:${this.qrCode.target_id}`
        }
      }
    }
  },
  created() {
    this.loadGuideItems()
  },
  methods: {
    async loadGuideItems() {
      try {
        this.guideItems = await GuideItemsRepository.getAll()
        this.loadingGuideItems = false
      } catch (error) {
        this.handleApiError(error, "Fehler beim Laden der Inhalte")
      }
    },
    parseGuideItemTree(items) {
      let result = []
      let that = this
      items.forEach(function(item) {
        if (ALLOWED_TYPES.includes(item.type)) {
          let entry = {
            label: item.name,
            value: `GuideItem:${item.id}`,
            children: that.parseGuideItemTree(item.children || [])
          }
          if (entry.children.length === 0) {
            delete entry.children
          }
          result.push(entry)
        }
      })
      return result
    },
    handleTargetChange(value) {
      if (value) {
        const [targetType, targetId] = value.split(":")
        this.qrCode.target_type = targetType
        this.qrCode.target_id = parseInt(targetId)
      } else {
        this.qrCode.target_type = null
        this.qrCode.target_id = null
      }
    }
  }
}
</script>
